import { render, staticRenderFns } from "./BtnGroupToggle.vue?vue&type=template&id=656e44ec&"
import script from "./BtnGroupToggle.vue?vue&type=script&lang=js&"
export * from "./BtnGroupToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports